export default {
  catAll: 'Vše',
  catPurchasing: 'Nákup',
  catKeyActivation: 'Aktivace klíče',
  catAccount: 'Účet',
  catBilling: 'Platby',
  catRefunds: 'Vrácení peněz',

  eyebrow: 'FAQ',
  eyebrowSubtitle: 'Najděte odpovědi na časté dotazy',

  heroTitle: 'Často kladené',
  heroTitleAccent: 'dotazy',
  heroSubtitle: 'Přístup k databázi systému navázán. Vyhledejte řešení nebo procházejte kategorie níže.',
  searchPlaceholder: 'Hledat v databázi...',
  noResults: 'Žádné výsledky. Zkuste jiné hledání nebo kategorii.',

  stillNeedHelpTitle: 'Stále potřebujete pomoc?',
  stillNeedHelpBody: 'Pokud váš dotaz není výše zodpovězen, napište nám a náš tým se vám ozve.',
  contactSupport: 'Kontaktovat podporu',

  q1: 'Jak si koupím herní klíč?',
  q1Intro: 'Nákup klíče na PlayStock je okamžitý, automatizovaný proces. Stačí postupovat podle těchto kroků:',
  q1Step1: 'Procházejte katalog a otevřete hru, kterou chcete.',
  q1Step2: 'Klikněte na „Přidat do košíku“ a poté otevřete košík.',
  q1Step3: 'Přejděte k pokladně a zaplaťte zůstatkem ve své peněžence (v případě potřeby ji nejprve dobijte).',
  q1Step4: 'Jakmile platba proběhne, klíč se okamžitě objeví v sekci „Mé objednávky“ — odkryjte ho a aktivujte.',

  q2: 'Jsou klíče regionálně omezené?',
  q2A: 'Některé klíče mají regionální omezení. Na každé stránce produktu je upozornění „Regionální omezení“, pokud lze klíč aktivovat pouze v určitých regionech; klíče bez regionálního omezení fungují celosvětově. Před nákupem si vždy zkontrolujte stránku produktu.',

  q3: 'Jak dlouho trvá aktivace?',
  q3A: 'Doručení je okamžité — jakmile platba proběhne, klíč je k dispozici v sekci Mé objednávky. Jeho aktivace na platformě (Steam, Epic atd.) obvykle trvá méně než minutu.',

  q4: 'Jak aktivuji svůj klíč?',
  q4A: 'Otevřete Mé objednávky, odkryjte klíč a poté ho uplatněte v příslušném klientovi platformy (např. Steam → Hry → Aktivovat produkt). Každá objednávka obsahuje podrobný návod k aktivaci krok za krokem.',

  q5: 'Jak dobiji svou peněženku?',
  q5A: 'Přejděte na svůj Přehled nebo k Pokladně a klikněte na „Dobít“. Zvolte částku a zaplaťte přes hostovanou pokladnu; zůstatek vaší peněženky se aktualizuje, jakmile bude platba potvrzena.',

  q6: 'Jak ověřím svůj e-mail?',
  q6A: 'Po registraci vám zašleme ověřovací odkaz e-mailem. Kliknutím na něj ověříte svou adresu — tím se odemknou nákupy až do výše 50 €. V případě potřeby ho můžete znovu odeslat ze svého Přehledu.',

  q7: 'Mohu smazat svůj účet?',
  q7A: 'Ano. V Nastavení účtu → Nebezpečná zóna můžete naplánovat smazání. Váš účet bude odstraněn po 7denní ochranné lhůtě a kdykoli předtím můžete smazání zrušit.',

  q8: 'Jaké jsou podmínky vrácení peněz?',
  q8A: 'Neodkryté klíče lze vrátit. Jakmile je klíč odkryt nebo aktivován, nelze ho vrátit, protože digitální klíče jsou nevratné. Pokud se s vaší objednávkou něco pokazilo, kontaktujte podporu.',
};
